module.exports = __webpack_public_path__ + "static/media/blog7_3.46b8e7d9.webp";